<template>
  <div>
    <v-dialog v-model="dialog" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-text class="text-second pa-5 px-7">
          Apakah anda yakin mengkonfimasi pembayaran <b>{{ detail.additional_cost_label }}</b> ?
        </v-card-text>
        <v-card-text>
          <quill-editor 
            ref="myTextEditor"
            :options="option"
            v-model="detail.additional_cost_desc">
          </quill-editor>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            outlined
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :disabled="process.run"
            :loading="process.run"
            @click="confirmation">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            outlined
            color="red"
            class="text-capitalize red--text mx-1"
            :disabled="process.run"
            @click="dialog = false; detail = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-card
          style="border-radius: 0px;"
          flat>
          <div style="background: var(--color-primary)">
            <v-card-title class="subtitle-2 white--text">
              Biaya Lain-lain / Titipan
            </v-card-title>
            <v-card-subtitle class="white--text line-text-first pt-2 caption">
              Jika pembeli / konsumen ada penambahan / permintaan atas unit yang di booking, <i>contoh: "kamar mandi / kolam renang"</i>. Maka anda dapat menambahkan biaya lain-lain di bawah ini. Lalu tekan tombol simpan perubahan.
            </v-card-subtitle>
          </div>
          <v-card-text v-if="add">
            <v-btn
              small
              outlined
              color="green"
              class="text-capitalize mr-2"
              @click="addOther()">
              Tambahkan Biaya Lain-lain / Titipan
            </v-btn>
            <v-btn
              v-if="form.other_fee.length > 0"
              small
              outlined
              color="red"
              class="text-capitalize"
              @click="reset()">
              Hapus Semua
            </v-btn>
            <v-divider class="mt-5 mb-2" v-if="form.other_fee.length > 0"/>
            <v-row
              v-for="(item, index) in form.other_fee"
              :key="index">
              <v-col cols="1">
                <div style="width: 32px;">
                  <v-chip
                    class="px-0 d-flex justify-center align-center"
                    style="width: 100px; border-radius: 0px !important;"
                    label>
                    {{ index+1 }}
                  </v-chip>
                  <v-chip
                    style="border-radius: 0px !important;"
                    label
                    color="red"
                    class="px-1 text-center cursor-pointer"
                    :disabled="item.status !== 'open'"
                    @click="removeOther(index, item.id)">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="11">
                <v-row>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      dense
                      outlined
                      label="Lain-lain / Titipan"
                      :color="style.primary"
                      prepend-inner-icon="mdi-clock-check-outline"
                      :disabled="item.status !== 'open'"
                      v-model="item.title">
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-currency-field 
                      dense
                      outlined
                      label="Biaya"
                      :color="style.primary"
                      prepend-inner-icon="mdi-cash-100"
                      :disabled="item.status !== 'open'"
                      v-model="item.price">
                    </v-currency-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" class="py-0">
                    <v-menu
                      ref="tempo"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="item.picker.tempo">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          outlined
                          readonly
                          :color="style.primary"
                          prepend-inner-icon="mdi-calendar-month"
                          label="Jatuh Tempo"
                          :disabled="item.status !== 'open'"
                          v-model="item.duedate"
                          v-on="on">
                        </v-text-field>
                      </template>
                      <v-date-picker 
                        :color="style.primary"
                        v-model="item.duedate"
                        @input="item.picker.tempo = false"
                        @change="item.paydate = ''">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-menu
                      ref="pay"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="item.picker.pay">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          outlined
                          readonly
                          :color="style.primary"
                          prepend-inner-icon="mdi-calendar-month"
                          label="Tanggal Bayar"
                          :disabled="item.status !== 'open'"
                          v-model="item.paydate"
                          v-on="on">
                        </v-text-field>
                      </template>
                      <!-- <v-date-picker 
                        color="#4FC3F7"
                        v-model="item.paydate"
                        @input="item.picker.pay = false"
                        @change="item.status = true">
                      </v-date-picker> -->

                      <v-date-picker 
                        :color="style.primary"
                        v-model="item.paydate"
                        @input="item.picker.pay = false">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                
                <quill-editor 
                  ref="myTextEditor"
                  :options="option"
                  v-model="item.desc">
                </quill-editor>
              </v-col>
            </v-row>
            <v-btn
              v-if="form.other_fee.length > 0"
              color="teal"
              class="text-capitalize white--text"
              :disabled="process.run"
              :loading="process.run"
              @click="save">
              <v-icon small class="mr-1">mdi-check</v-icon>
              Simpan Biaya Lain-lain / Titipan
            </v-btn>
          </v-card-text>

          <v-card-text v-if="!add">
            <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
              small
              outlined
              color="orange"
              class="text-capitalize mr-2"
              @click="add = true">
              Ubah Biaya Lain-lain / Titipan
            </v-btn>
            <v-divider class="mt-5 mb-2" v-if="form.other_fee.length > 0 && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"/>
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left pl-0" width="300">Lain-lain / Titipan</th>
                      <th class="text-left">Biaya</th>
                      <!-- <th class="text-left">Keterangan</th> -->
                      <th class="text-right"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(item, index) in process.run ? 7 : list" 
                      :key="index">
                      <td class="text-second pl-0">
                        {{ item.additional_cost_label }}
                      </td>
                      <td class="caption text-second">
                        <v-list-item class="pa-0">
                          <v-list-item-content>
                            <v-list-item-title class="caption text-second mb-1">
                              {{ parseInt(item.additional_cost_value) | price }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                              Tempo {{ item.additional_cost_duedate | date }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </td>
                      <!-- <td class="caption text-second">
                        <span v-html="item.additional_cost_desc"></span>
                      </td> -->
                      <td class="caption text-right pr-0">
                        <!-- JIKA MASIH AKTIF -->
                        <div v-if="booking.company_project_is_active === '1'">
                          <!-- SUPERUSER | ADMINISTRATOR -->
                          <div v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')">
                            <v-list-item class="pa-0" v-if="item.additional_cost_status !== 'open'">
                              <v-list-item-content>
                                <v-list-item-title class="caption font-weight-bold mb-1"
                                  :class="item.additional_cost_status === 'confirmed' ? 'color-default' : 'teal--text'">
                                  {{ item.additional_cost_status === 'confirmed' ? 'Menunggu Konfirmasi Finance' : 'Terbayar' }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                  {{ item.additional_cost_status === 'confirmed' ? 'Dibayarkan' : 'Pada' }} 
                                  {{ item.additional_cost_paydate | date }}
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action v-if="item.additional_cost_status === 'close'">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      elevation="0"
                                      min-width="25"
                                      height="25"
                                      class="pa-0"
                                      color="teal"
                                      :loading="process.print"
                                      :disabled="process.print"
                                      @click="prints(item.additional_cost_id)"
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon small color="white">mdi-microsoft-excel</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Print</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                            <v-btn
                              v-if="item.additional_cost_status === 'open'"
                              small
                              outlined
                              :color="style.primary"
                              class="text-capitalize"
                              @click="dialog = true; detail = item;">
                              <v-icon small class="mr-1">mdi-check</v-icon>
                              Konfirmasi Pembayaran
                            </v-btn>
                          </div>

                          <!-- FINANCE -->
                          <div v-if="user.user_company_roles_name.includes('finance')">
                            <v-list-item class="pa-0" v-if="item.additional_cost_status === 'open'">
                              <v-list-item-content>
                                <v-list-item-title class="caption font-weight-bold red--text mb-1">
                                  Belum Dibayar
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                  Jatuh Tempo {{ item.additional_cost_duedate | date }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="pa-0" v-if="item.additional_cost_status === 'close'">
                              <v-list-item-content>
                                <v-list-item-title class="caption font-weight-bold teal--text mb-1">
                                  Terbayar
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                  Pada {{ item.additional_cost_paydate | date }}
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      elevation="0"
                                      min-width="25"
                                      height="25"
                                      class="pa-0"
                                      color="teal"
                                      :loading="process.print"
                                      :disabled="process.print"
                                      @click="prints(item.additional_cost_id)"
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon small color="white">mdi-microsoft-excel</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Print</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                            <v-btn
                              v-if="item.additional_cost_status === 'confirmed'"
                              small
                              width="200"
                              outlined
                              :color="style.primary"
                              class="text-capitalize"
                              @click="dialog = true; detail = item;">
                              <v-icon small class="mr-1">mdi-check</v-icon>
                              Konfirmasi Pembayaran
                            </v-btn>
                          </div>

                          <!-- SUPERVISOR | MARKETING | DEVELOPER -->
                          <div v-if="!user.user_company_roles_name.includes('superuser') && !user.user_company_roles_name.includes('administrator') && !user.user_company_roles_name.includes('finance')">
                            <v-list-item class="pa-0">
                              <v-list-item-content>
                                <v-list-item-title class="caption font-weight-bold mb-1"
                                  :class="item.additional_cost_status === 'open' ? 'red--text' : item.additional_cost_status === 'confirmed' ? 'color-default' : 'teal--text'">
                                  {{ item.additional_cost_status === 'open' ? 'Belum Dibayar' : item.additional_cost_status === 'confirmed' ? 'Menunggu Konfirmasi Finance' : 'Terbayar' }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                  {{ item.additional_cost_status === 'open' ? 'Jatuh Tempo' : item.additional_cost_status === 'confirmed' ? 'Dibayarkan' : 'Pada' }}
                                  <span v-if="item.additional_cost_status === 'open'">
                                    {{ item.additional_cost_duedate | date }}
                                  </span>
                                  <span v-if="item.additional_cost_status !== 'open'">
                                    {{ item.additional_cost_paydate | date }}
                                  </span>
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action v-if="item.additional_cost_status === 'close'">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      elevation="0"
                                      min-width="25"
                                      height="25"
                                      class="pa-0"
                                      color="teal"
                                      :loading="process.print"
                                      :disabled="process.print"
                                      @click="prints(item.additional_cost_id)"
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon small color="white">mdi-microsoft-excel</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Print</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                          </div>
                        </div>

                        <!-- JIKA SUDAH HABIS MASA AKTIF -->
                        <div v-if="booking.company_project_is_active === '0'">
                          <span class="red--text font-weight-bold">
                            Langganan Habis
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import moment from "moment";
  export default {
    data () {
      return {
        dialog: false,
        fab: false,
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        add: false,
        detail: {},
        list: [],
        form: {
          transaction_id: '',
          other_fee: [],
          delete: []
        },
        process: {
          run: false,
          print: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      
    },
    props: [
      'booking'
    ],
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch() {
        this.process.run = true
        await get(`auth/transaction/additional-cost/detail`, {
          params: {
            transaction_id: this.$route.query.transaction
          }
        })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.run = false
            this.add = res.data.results.length > 0 ? false : true
            this.list = res.data.results
            
            this.reset()

            res.data.results.forEach(item => {
              this.form.transaction_id = item.additional_cost_transaction_id
              this.form.other_fee.push({
                id: item.additional_cost_id,
                title: item.additional_cost_label,
                price: parseInt(item.additional_cost_value),
                desc: item.additional_cost_desc,
                duedate: item.additional_cost_duedate,
                paydate: item.additional_cost_paydate,
                picker: item.picker,
                status: item.additional_cost_status
              })
            })
          }
        })
      },
      onScroll (e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset || e.target.scrollTop || 0
        this.fab = top > window.innerHeight-100
      },
      reset() {
        this.form = {
          transaction_id: this.$route.query.transaction,
          other_fee: [],
          delete: []
        }
      },
      addOther() {
        this.form.transaction_id = this.$route.query.transaction
        this.form.other_fee.push({
          id: 0,
          title: '',
          price: '',
          desc: '',
          duedate: '',
          paydate: '',
          picker: {
            tempo: false,
            pay: false
          },
          status: 'open'
        })
      },
      removeOther(index, id) {
        this.form.other_fee.splice(index, 1)
        this.form.delete.push(id)
      },
      async save() {
        this.error.message = ''
        this.process.run = true
        
        let forms = Object.assign({}, this.form)
        forms.delete = JSON.stringify(forms.delete)
        
        await post(`auth/transaction/additional-cost/create`, {
          data: forms
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.dialog = false

            this.fetch()
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      },
      async confirmation() {
        this.error.message = ''
        this.process.run = true

        let form = {
          additional_cost_id: this.detail.additional_cost_id,
          paydate: '',
          desc: this.detail.additional_cost_desc,
          status: this.user.user_company_roles_name.includes('finance') ? 'close' : 'confirmed'
        }

        await post(`auth/transaction/additional-cost/update-payment`, {
          data: form
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.dialog = false
            this.detail = {}

            // window.open(res.data.url, '_blank')

            this.fetch()
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      },
      async prints(id) {
        this.process.print = true

        let params = {
          additional_cost_id: id
        }

        await get(`auth/transaction/additional-cost/print`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.print = false
            window.open(res.data.url, '_blank')
          }
          console.log('ini data res',res)
        })
      }
    }
  }
</script>